export const formatTimestampToString = (timestamp) => {
  if (!timestamp || timestamp < 0) {
    return "";
  }
  const startDate = new Date(timestamp * 1000);
  const endDate = new Date((timestamp + 30 * 60) * 1000);
  const year = startDate.getFullYear();
  const month = String(startDate.getMonth() + 1).padStart(2, "0");
  const day = String(startDate.getDate()).padStart(2, "0");
  const dateStr = `${year}.${month}.${day}`;
  const startHour = String(startDate.getHours()).padStart(2, "0");
  const startMinute = String(startDate.getMinutes()).padStart(2, "0");
  const startTimeStr = `${startHour}:${startMinute}`;
  const endHour = String(endDate.getHours()).padStart(2, "0");
  const endMinute = String(endDate.getMinutes()).padStart(2, "0");
  const endTimeStr = `${endHour}:${endMinute}`;
  return `${dateStr} (${startTimeStr} ~ ${endTimeStr})`;
};

export const getTomorrowUnix = () => {
  return Math.floor((new Date().getTime() + 24 * 60 * 60 * 1000) / 1000);
};

export const formatDateDDMMYYYY = (date) => date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });

export const formatDateYYMMDD = (date) => {
  const yy = String(date.getFullYear()).slice(2);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yy}/${mm}/${dd}`;
};

export const formatDateDD_MM_YY = (date) => {
  const yy = String(date.getFullYear()).slice(2);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${dd}/${mm}/${yy}`;
};

export const formatTimeToHoursAndMinutes = (seconds, units) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const { hourUnit = "hour", hourUnitPlural = hourUnit + "s", minuteUnit = "minute", minuteUnitPlural = minuteUnit + "s" } = units || {};

  let result = "";
  if (hours > 0) {
    result += `${hours} ${hours > 1 ? hourUnitPlural : hourUnit}`;
  }
  if (minutes > 0) {
    if (result) result += " ";
    result += `${minutes} ${minutes > 1 ? minuteUnitPlural : minuteUnit}`;
  }

  return result || `0 ${minuteUnitPlural}`;
};

export const formatTimeToMinutesAndSeconds = (seconds, units) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const { minuteUnit = "minute", minuteUnitPlural = minuteUnit + "s", secondUnit = "second", secondUnitPlural = secondUnit + "s" } = units || {};

  let result = "";
  if (minutes > 0) {
    result += `${minutes} ${minutes > 1 ? minuteUnitPlural : minuteUnit}`;
  }
  if (remainingSeconds > 0) {
    if (result) result += " ";
    result += `${remainingSeconds} ${remainingSeconds > 1 ? secondUnitPlural : secondUnit}`;
  }

  return result || `0 ${secondUnitPlural}`;
};

export const formatTimeToMMSS = (seconds, unit = 's') => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');
  
  return `${formattedMinutes}:${formattedSeconds}${unit}`;
};

export const convertTimeToHHMMFormat = (dayString) => {
  const day = new Date(dayString);
  const hours = String(day.getHours()).padStart(2, "0");
  const minutes = String(day.getMinutes()).padStart(2, "0");
  const time = `${hours}:${minutes}`;
  return time;
};

export const convertHHMMFormatToTime = (timeString) => {
  if (!timeString) return null;
  const [hours, minutes] = timeString.split(":").map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};
